import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import Button from '../../../../../../../../components/Button'
import GroupEntity from '../../../../../../../../components/GroupEntity'
import StackPreloader from '../../../StackPreloader'
import VirtualizedList from '../../../../../../../../components/VirtualizedList'

import hocConnect from './hocConnect'

import { NEW_GROUP } from '../../../../../GroupStack/constants'

import { LOCALE_PREFIX, VIRTUAL_LIST_ID } from './constants'

import './style.scss'

@hocConnect
export default class GroupsContent extends Component {
    static propTypes = {
        groupsCollection: IPropTypes.list.isRequired,
        loaded: PropTypes.bool.isRequired,
        loadGroups: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
        toggleGroupStack: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        const { loading, loaded } = this.props

        if (!loading && !loaded) {
            this.props.loadGroups()
        }
    }

    addGroupButtonHandler = () => {
        const { toggleGroupStack } = this.props

        toggleGroupStack(NEW_GROUP)
    }

    renderLoader = () => {
        const { loading, loaded } = this.props

        return loading || !loaded ? <StackPreloader /> : null
    }

    renderItem = (index) => {
        const { groupsCollection } = this.props

        const group = groupsCollection.get(index, null)
        if (!group) return null

        return <GroupEntity key={`group-${index}`} id={_.toString(group.get('id'))} />
    }

    render() {
        const { groupsCollection } = this.props

        const buttonText = <FormattedMessage id={`${LOCALE_PREFIX}.addButton`} />

        const button = (
            <div className={'add-group-button'}>
                <Button active onClickHandler={this.addGroupButtonHandler} text={buttonText} className={'add-group'} />
            </div>
        )

        return (
            <div className={'entity-stack-groups-content'}>
                {this.renderLoader()}
                <VirtualizedList
                    id={VIRTUAL_LIST_ID}
                    itemsCount={groupsCollection.size}
                    itemHeight={61}
                    renderItem={this.renderItem}
                    beforeComponent={button}
                />
            </div>
        )
    }
}
